/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface CategoryAmountDTO
 */
export interface CategoryAmountDTOOptional {
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  categoryId?: number;
  /**
   *
   * @type {string}
   * @memberof CategoryAmountDTO
   */
  categoryName?: string;
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  amount?: number;
}

export interface CategoryAmountDTO extends CategoryAmountDTOOptional {
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  categoryId: number;
  /**
   *
   * @type {string}
   * @memberof CategoryAmountDTO
   */
  categoryName?: string;
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  amount: number;
}

export interface CategoryAmountDTOTrackedI {
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  categoryId?: number;
  categoryIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CategoryAmountDTO
   */
  categoryName?: string;
  categoryNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CategoryAmountDTO
   */
  amount?: number;
  amountIsSet: boolean;
}

transformDatesMap.set(
  "CategoryAmountDTO",
  function (model: CategoryAmountDTO) {},
);

export type CategoryAmountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  categoryId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  categoryName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  amount: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CategoryAmountDTOMeta: CategoryAmountDTOMetaI =
  {} as CategoryAmountDTOMetaI;
CategoryAmountDTOMeta = typeMeta("CategoryAmountDTO", {
  categoryId: propertyMeta(
    "categoryId",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  categoryName: propertyMeta(
    "categoryName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  amount: propertyMeta("amount", false, true, false, MetaTypesBase.number),
});

const metaI = CategoryAmountDTOMeta;

registerMeta(() => {});

export class CategoryAmountDTOTracked implements CategoryAmountDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  categoryId__I?: number = undefined;
  categoryIdIsSet: boolean = false;
  set categoryId(v: undefined | number) {
    if (v !== undefined) {
      this.categoryId__I = v;
      this.categoryIdIsSet = true;
    } else {
      this.categoryId__I = v || undefined;
      this.categoryIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get categoryId() {
    return this.categoryId__I;
  }
  categoryName__I?: string = undefined;
  categoryNameIsSet: boolean = false;
  set categoryName(v: undefined | string) {
    if (v !== undefined) {
      this.categoryName__I = v;
      this.categoryNameIsSet = true;
    } else {
      this.categoryName__I = v || undefined;
      this.categoryNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get categoryName() {
    return this.categoryName__I;
  }
  amount__I?: number = undefined;
  amountIsSet: boolean = false;
  set amount(v: undefined | number) {
    if (v !== undefined) {
      this.amount__I = v;
      this.amountIsSet = true;
    } else {
      this.amount__I = v || undefined;
      this.amountIsSet = true;
    }
    this.changeTracker = true;
  }
  get amount() {
    return this.amount__I;
  }
  constructor(config?: CategoryAmountDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: CategoryAmountDTOOptional,
    options?: AssignOptions,
  ): CategoryAmountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.categoryId &&
      this.categoryIdApplyFilter(optionsRequired.filter)
    ) {
      this.categoryId = config.categoryId;
      if (optionsRequired.unassign) this.categoryIdIsSet = false;
      else this.categoryIdIsSet = true;
    }
    if (
      config.categoryName &&
      this.categoryNameApplyFilter(optionsRequired.filter)
    ) {
      this.categoryName = config.categoryName;
      if (optionsRequired.unassign) this.categoryNameIsSet = false;
      else this.categoryNameIsSet = true;
    }
    if (config.amount && this.amountApplyFilter(optionsRequired.filter)) {
      this.amount = config.amount;
      if (optionsRequired.unassign) this.amountIsSet = false;
      else this.amountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CategoryAmountDTOTrackedI {
    const cloned = {} as CategoryAmountDTOTrackedI;
    if (
      this.categoryIdIsSetDeep() &&
      this.categoryIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryIdIsSet = true;
      cloned.categoryId = this.categoryId;
    } else {
      //cloned.categoryIdIsSet = false
    }
    if (
      this.categoryNameIsSetDeep() &&
      this.categoryNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryNameIsSet = true;
      cloned.categoryName = this.categoryName;
    } else {
      //cloned.categoryNameIsSet = false
    }
    if (
      this.amountIsSetDeep() &&
      this.amountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountIsSet = true;
      cloned.amount = this.amount;
    } else {
      //cloned.amountIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CategoryAmountDTOTrackedI {
    if (!this.categoryIdApplyFilter(filter)) this.categoryIdIsSet = false;

    if (!this.categoryNameApplyFilter(filter)) this.categoryNameIsSet = false;

    if (!this.amountApplyFilter(filter)) this.amountIsSet = false;

    return this;
  }
  categoryIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryAmountDTOMeta.categoryId,
      CategoryAmountDTOMeta,
      this.categoryId,
      this,
    );
  }
  categoryIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryIdIsSet && this.categoryIdApplyFilter(filter)) return true;

    return false;
  }
  categoryNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryAmountDTOMeta.categoryName,
      CategoryAmountDTOMeta,
      this.categoryName,
      this,
    );
  }
  categoryNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryNameIsSet && this.categoryNameApplyFilter(filter))
      return true;

    return false;
  }
  amountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CategoryAmountDTOMeta.amount,
      CategoryAmountDTOMeta,
      this.amount,
      this,
    );
  }
  amountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountIsSet && this.amountApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.categoryIdIsSetDeep(filter)) return true;
    if (this.categoryNameIsSetDeep(filter)) return true;
    if (this.amountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
